export function hasPermission({ permissions, permissionId }) {
  const permission = permissions?.find((p) => p.permissionId === permissionId);
  if (!permission) {
    return false;
  }

  switch (permission.permissionLevel) {
    case 'All':
      return true;
    case 'None':
      return false;
    default:
      return false;
  }
}
